<template>
    <div id="verifiedPanel">
        <popup ref="popup" type="center" @close="popClose" :coverClose="false">
            <div class="verified_panel">
                <div class="panel_notice">用户须知: 根据国家相关法律法规，请微信实名认证后继续使用！</div>
                <div class="verified_step">
                    <div class="step_label">
                        <div class="label_title">实名认证进行中</div>
                        <div class="label_desc">二秒快速认证，保障用户信息安全</div>
                    </div>
                    <div class="step_content">
                        <div class="step_item active">
                            <div class="step_point"></div>
                            <div class="step_name">微信扫码</div>
                        </div>
                        <div class="step_item">
                            <div class="step_point"></div>
                            <div class="step_name">授权</div>
                        </div>
                        <div class="step_item">
                            <div class="step_point"></div>
                            <div class="step_name">完成</div>
                        </div>
                    </div>
                </div>
                <div class="panel_content">
                    <div class="code_wrap">
                        <div class="scan_box">
                            <div class="jiao jiao1"></div>
                            <div class="jiao jiao2"></div>
                            <div class="jiao jiao3"></div>
                            <div class="jiao jiao4"></div>
                            <img class="code_img" src="../views/img/gzh_code.jpg" alt="" srcset="">
                        </div>
                    </div>
                    <div class="panel_tips">
                        <div class="tips_title">温馨提示：</div>
                        <div class="tips_text">我们创建平台的初衷是为了提高和帮助大家的工作效率，请勿提问违法国家法律法规的相关提问，否则我们将上报国家相关部门!</div>
                    </div>
                </div>
                <div class="close_btn" @click="popClose"></div>
            </div>
        </popup>
    </div>
</template>
<script type="text/ecmascript-6">
    import popup from "COMPONENTS/Popup.vue"
    export default {
        components:{popup},
        data() {
            return {
                
            }
        },
        created() {
        
        },
        methods: {
            show(){
                this.$refs.popup.show();
            },
            popClose(){
                this.$refs.popup.close();
            },
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .verified_panel{
        width: 560px;
        position: relative;
        .panel_notice{
            font-size: 14px;
            line-height: 50px;
            background-color: #ffffcc;
            color: #2ba33a;
            text-align: center;
        }
        .verified_step{
            padding: 0 32px 18px;
            height: 102px;
            background-color: #f6f6f6;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .step_label{
                .label_title{
                    font-size: 20px;
                    line-height: 34px;
                }
                .label_desc{
                    font-size: 14px;
                    line-height: 28px;
                }
            }
            .step_content{
                padding-bottom: 12px;
                display: flex;
                justify-content: space-between;
                width: 168px;
                margin-right: 9px;
                .step_item{
                    position: relative;
                    &.active{
                        .step_point{
                            background-color: #ff5e70;
                            &::after{
                                border-color: #ff5e70;
                            }
                        }
                        .step_name{
                            color: #ff5e70;
                        }
                    }
                    &:last-child{
                        .step_point{
                            &::after{
                                content: none;
                            }
                        }
                    }
                    .step_point{
                        width: 16px;
                        height: 16px;
                        border-radius: 8px;
                        background-color: #d9dbda;
                        &::after{
                            content: "";
                            display: block;
                            width: 60px;
                            border-bottom: 1px solid #d9dbda;
                            position: absolute;
                            top: 7px;
                            right: -60px;
                        }
                    }
                    .step_name{
                        position: absolute;
                        line-height: 30px;
                        font-size: 14px;
                        color: #999;
                        left: 50%;
                        bottom: -30px;
                        transform: translateX(-50%);
                        white-space: nowrap;
                    }
                }
            }
        }
        .panel_content{
            background-color: #fff;
            padding: 0 30px 30px;
            .code_wrap{
                border-radius: 12px;
                position: relative;
                top: -22px;
                padding-top: 70px;
                background-color: #fff;
                .scan_box{
                    width: 272px;
                    height: 272px;
                    margin: 0 auto 40px;
                    position: relative;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .jiao{
                        position: absolute;
                        width: 16px;
                        height: 16px;
                        border: 2px solid #fe5566;
                        &.jiao1{
                            top: 0;
                            left: 0;
                            border-bottom-color: transparent;
                            border-right-color: transparent;
                        }
                        &.jiao2{
                            top: 0;
                            right: 0;
                            border-bottom-color: transparent;
                            border-left-color: transparent;
                        }
                        &.jiao3{
                            bottom: 0;
                            right: 0;
                            border-top-color: transparent;
                            border-left-color: transparent;
                        }
                        &.jiao4{
                            bottom: 0;
                            left: 0;
                            border-top-color: transparent;
                            border-right-color: transparent;
                        }
                    }
                    .code_img{
                        width: 95%;
                        height: 95%;
                        display: block;
                    }
                }
            }
        }
        .panel_tips{
            font-size: 14px;
            line-height: 26px;
            color: #666;
            .tips_title{
                color: #000;
            }
        }
        .close_btn{
            position: absolute;
            bottom: -70px;
            left: 50%;
            margin-left: -35px;
            width: 48px;
            height: 48px;
            background-image: url("./img/coupon-colse.png");
            background-size: 100% 100%;
            background-color: rgba(153,153,153,0.6);
            cursor: pointer;
            border-radius: 50%;
        }
    }
</style>